export class Hotel {
  id: number;
  code: string;
  name: string;
  address: string | null;
  city_id: number | null;
  country_id: number | null;
  country_name?: string | null;
  post_code: string | null;
  email: string | null;
  category_id: number | null;
  hotel_chain_id: number | null;
  logo_url: string | null;
  star_level: number | null;
  currency_id: number | null;
  currency_name?: string | null;
  currency_code?: string | null;
  currency_precision?: number | null;
  currency_decimal_digits?: number | null;
  is_shared_guest_data: boolean | null;
  last_modified: Date | null;
  last_modified_by: number | null;
  created: Date | null;
  created_by: number | null;
  sidebar_menu_logo_url: string | null = null;
  show_sidebar_menu_logo: boolean = false;
}
